import React, { useMemo } from 'react';
import { FlatContentCard } from '@shared/ui/atoms/FlatContentCard';
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { selectAllMeetingRooms } from '@features/settings/pages/meeting-rooms/meeting-rooms-settings.duck';
import Colours from '@shared/ui/atoms/Colours';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import moment from "moment";
import { PRETTY_DATE_FORMAT } from '@shared/utils/DateUtils';
import { EnrichedMeetingRoomBooking, RoomBookingSource } from "../models/MeetingRooms";
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import { BodyLarge, BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { findMeetingRoomInMeetingRooms } from "../models/MeetingRoomHelper";
import { DialogIdentifiers, openDialogWithPayload } from '@shared/store/dialog.duck';
import { MeetingRoomSourceIcon } from "./MeetingRoomSourceIcon";
import { MeetingRoomBookingSourcePill } from "./MeetingRoomBookingSourcePill";
import { smallTablet } from '@shared/ui/atoms/MediaQueries';

export function MeetingRoomBookingList(props: Props) {
  const {groupedBookings} = props;
  const dispatch = useDispatch();
  const meetingRooms = useSelector(selectAllMeetingRooms);

  const dates = useMemo(() => {
    return Object.keys(groupedBookings).sort();
  }, [groupedBookings])

  const onBookingClick = (booking: EnrichedMeetingRoomBooking) => {
    dispatch(openDialogWithPayload({
      payload: { booking: booking },
      activeDialog: DialogIdentifiers.EditBookMeetingRoom
    }));
  }

  return (
    <>
      {dates.map((date: string, key) => (
        <React.Fragment key={key}>
          <HeaderContentCard>
            <HeadlineSmall>{moment(date).format(PRETTY_DATE_FORMAT)}</HeadlineSmall>
          </HeaderContentCard>
          {groupedBookings[date].map((booking: EnrichedMeetingRoomBooking, keyy: number) => (<MeetingRoomContentCard key={keyy} onClick={() => onBookingClick(booking)}>
            <Row>
              <Column style={{marginRight: 16}}>
                <UserAvatarAndName colour={'darkBlue'}
                                   hideName={true}
                                   firstName={booking.firstName}
                                   lastName={booking.lastName} />
              </Column>
              <MeetingRoomBookingInfoColumn>
                <BodyLarge className={'meetingRoomBooking__name'} weight={600}><MeetingRoomSourceIcon isOutlook={booking.source === RoomBookingSource.OUTLOOK || booking.source === RoomBookingSource.SYSTEM_LINKED_TO_OUTLOOK || booking.source === RoomBookingSource.EDITED_SYSTEM_LINKED_TO_OUTLOOK} />{booking.name}</BodyLarge>
                <BodyRegular>{findMeetingRoomInMeetingRooms(meetingRooms, booking.teamTodayMeetingRoomId)?.name ?? 'Not Found'}</BodyRegular>
                <BodyRegular>{moment(booking.startDateTime).format('Do MMMM')} - {moment(booking.startDateTime).format('h:mm a')} - {moment(booking.endDateTime).format('h:mm a')}</BodyRegular>
              </MeetingRoomBookingInfoColumn>
              <Column className={'meetingRoomBooking__source'}>
                <MeetingRoomBookingSourcePill source={booking.source} />
              </Column>
            </Row>
          </MeetingRoomContentCard>))}
        </React.Fragment>
      ))}
    </>
  )
}

interface Props {
  groupedBookings: any;
}

const Row = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
  overflow-wrap: break-word;
  .meetingRoomBooking__source {
    margin-top: 16px;
  }
  @media (${smallTablet}) {
    flex-direction: row;
    justify-content: flex-start;
    .meetingRoomBooking__source {
      margin-left: auto;
      margin-top: 0px;
    }
  }
  .meetingRoomBooking__name {
    word-break: break-all;
  }
`

const MeetingRoomContentCard = styled(FlatContentCard)`
  display: flex;
  margin-bottom: 16px;
  transition: background-color .1s ease-in-out, color .1s ease-in-out;
  cursor: pointer;
  &:hover {
    background-color: ${Colours.darkBlue};
    * {
      color: white;
    }
    .userAvatarAndName__avatar {
      background-color: white !important;
      color: ${Colours.darkBlue} !important;
    }
  }
  .userAvatarAndName__avatar {
    margin-bottom: 4px;
  }
  @media (${smallTablet}) {
    .userAvatarAndName__avatar {
      margin-bottom: 0;
    }
  }
`

const HeaderContentCard = styled(FlatContentCard)`
  margin-bottom: 16px;
  margin-top: 32px;
  &:first-child {
    margin-top: 0;
  }
`


const MeetingRoomBookingInfoColumn = styled.div`
  max-width: 100%;
  @media (${smallTablet}) {
    max-width: 70%;
  }
`
